import { render } from "./AlertNotification.vue?vue&type=template&id=487ed34c&scoped=true"
import script from "./AlertNotification.vue?vue&type=script&lang=js"
export * from "./AlertNotification.vue?vue&type=script&lang=js"

import "./AlertNotification.vue?vue&type=style&index=0&id=487ed34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487ed34c"]])

export default __exports__